import React, {useMemo} from 'react'
import styled from 'styled-components'
import {getCurrencyValue} from 'utils'
import {CheckboxItem, PackageIcon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopCartPackageContentItemProps} from './GiftShopCartPackageContentItemProps'

const StyledContainer = styled.div`
  ${({theme}) => ({
    borderBottom: `solid ${convertUnit(1)} ${theme.gray_1}`,
  })}
  display: flex;
  flex-direction: row;
  margin: 0 ${convertUnit(25)};
  padding: ${convertUnit(25)} 0;
  align-items: center;
`

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: ${convertUnit(25)};
  word-wrap: break-word;
  overflow-wrap: anywhere;
`

const StyledCartItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

const StyledDescriptionCreator = styled(Paragraph)`
  margin-top: ${convertUnit(2)};
`

const StyledDescriptionPrice = styled(Paragraph)`
  margin-top: ${convertUnit(2)};
`

const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledCheckboxItem = styled(CheckboxItem)`
  ${({theme}) => ({borderColor: theme.gray_5})}
`

export default function GiftShopCartPackageContentItem({
  data,
  isSelected,
  onSelect,
  onClickItem,
}: GiftShopCartPackageContentItemProps) {
  const {price, creator_name, tree_name} = data

  const handleRenderPrice = useMemo(
    () => (
      <StyledPriceContainer>
        <StyledDescriptionPrice
          fontSize="m"
          fontWeight="bold"
          color="primary_5">
          {getCurrencyValue(price)}
        </StyledDescriptionPrice>
      </StyledPriceContainer>
    ),
    [price],
  )

  return (
    <StyledContainer>
      <StyledCheckboxItem
        isSelected={isSelected}
        onClick={() => onSelect(!isSelected)}
      />
      <StyledCartItemContainer onClick={() => onClickItem && onClickItem(data)}>
        <PackageIcon
          size={96}
          style={{
            marginLeft: convertUnit(24),
          }}
        />
        <StyledDescriptionContainer>
          <Paragraph fontSize="m" fontWeight="bold">
            {tree_name}
          </Paragraph>
          <StyledDescriptionCreator
            fontSize="s"
            fontWeight="medium"
            color="gray_5">
            {creator_name}
          </StyledDescriptionCreator>
          {handleRenderPrice}
        </StyledDescriptionContainer>
      </StyledCartItemContainer>
    </StyledContainer>
  )
}
